import DemoFormDialog from "@/components/DemoFormDialog";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data/site";

export default function FinalCta({ title = "Ready to grow on WhatsApp?", sub = "Book a free demo and see how GrabNChat can transform your customer conversations.", ctaSource = "demo" }) {
  return (
    <section className="py-20 md:py-28 bg-[#0F172A] relative overflow-hidden" data-testid="final-cta">
      <div className="absolute inset-0 bg-dots opacity-30" />
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-[#25D366]/20 blur-3xl rounded-full" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
          {title}
        </h2>
        <p className="mt-6 text-lg text-slate-300 max-w-2xl mx-auto">{sub}</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <a href={`${BRAND.appUrl}/login`}>
            <Button className="w-full bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full px-7 h-12 font-semibold" data-testid="final-cta-start-btn">
              Start for Free <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </a>
          <DemoFormDialog source={ctaSource} trigger={
            <Button variant="outline" className="bg-transparent border-white/20 hover:bg-white/10 text-white hover:text-white rounded-full px-7 h-12 font-semibold" data-testid="final-cta-demo-btn">
              Book Free Demo
            </Button>
          } />
          <Link to="/pricing" className="self-center text-sm font-semibold text-slate-300 hover:text-white sm:ml-2" data-testid="final-cta-pricing-btn">
            View Pricing →
          </Link>
        </div>
      </div>
    </section>
  );
}
